<template>
  <div class="app-header">
    <div class="header-content">
      <div class="logo">
        <img src="/favicon.ico" alt="Logo" class="logo-img" />
        <span class="logo-text">太可智越TechB-家长端</span>
      </div>
      <el-menu
        :default-active="active"
        class="nav-menu"
        mode="horizontal"
        background-color="#fff"
        text-color="#606266"
        active-text-color="#409EFF"
        @select="onSelect"
      >
        <el-menu-item
          v-for="item in renderMenus"
          :key="item.path"
          :index="item.path"
        >
          <i :class="item.icon" />{{ item.label }}
        </el-menu-item>
      </el-menu>
      <div class="header-actions">
        <el-dropdown @command="emitUserAction" trigger="click">
          <el-button type="text" class="user-btn">
            <i class="el-icon-user-solid"></i>
            {{ userName }}
            <i class="el-icon-arrow-down el-icon--right" />
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="profile"
              ><i class="el-icon-user" />个人资料</el-dropdown-item
            >
            <!-- <el-dropdown-item command="settings"
              ><i class="el-icon-setting" />设置</el-dropdown-item
            > -->
            <el-dropdown-item command="logout" divided
              ><i class="el-icon-switch-button" />退出登录</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "AppHeader",
  props: {
    active: String,
    userName: String,
    role: { type: String, default: "student" },
  },
  computed: {
    // 基础菜单定义
    baseMenus() {
      return [
        {
          path: "/home",
          label: "学员管理",
          icon: "el-icon-user",
          roles: ["teacher", "admin"],
        },
      ];
    },
    renderMenus() {
      return this.baseMenus.filter(
        (m) => !m.roles || m.roles.includes(this.role)
      );
    },
  },
  methods: {
    onSelect(index) {
      if (index !== this.$route.path) this.$router.push(index);
      this.$emit("menu-select", index);
    },
    emitUserAction(cmd) {
      this.$emit("user-action", cmd);
    },
  },
};
</script>
<style scoped>
.app-header {
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 1000;
}
.header-content {
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  height: 60px;
}
.logo {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  font-size: 18px;
  color: #409eff;
  cursor: pointer;
}
.logo i {
  font-size: 24px;
}

.logo-img {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.logo-text {
  color: #303133;
}
.nav-menu {
  flex: 1;
  margin: 0 40px;
  border-bottom: none;
}
.nav-menu .el-menu-item {
  height: 60px;
  line-height: 60px;
  border-bottom: 2px solid transparent;
}
.nav-menu .el-menu-item.is-active {
  border-bottom-color: #409eff;
}
.header-actions {
  display: flex;
  align-items: center;
}
.user-btn {
  padding: 8px 16px;
  color: #606266;
  display: flex;
  align-items: center;
  gap: 6px;
}
@media (max-width: 768px) {
  .nav-menu {
    margin: 0 12px;
  }
  .logo-text {
    display: none;
  }
  .nav-menu .el-menu-item span {
    display: none;
  }
  .nav-menu .el-menu-item {
    width: 54px;
    text-align: center;
  }
}
</style>
